module.exports = __webpack_public_path__ + "static/media/gal0110.c12b38cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal01/gal0110.jpg
// module id = 336
// module chunks = 0